import { Box } from "@hightouch/htui";

import {
  type ContextItem,
  ContextRow,
} from "src/components/llm/components/compact-chat-input";
import {
  FillEmailPreview,
  type SelectedEmailAsset,
} from "src/components/llm/component-picker";
import { buildAdStudioTemplateContextItems } from "src/pages/ad-studio/components/ad-studio-template-context-items";
import type { ComposerSelections } from "src/pages/projects/amp-composer/composer-selections";
import type { SelectedOptions } from "src/pages/projects/amp-composer/use-composer-options";

type ComposerAttachmentsProps = {
  selected: SelectedOptions;
  /** The raw selections, so a removal keeps the picks hidden by the brand scope. */
  selections: ComposerSelections;
  onChange: (change: Partial<ComposerSelections>) => void;
};

/** The ad templates and email assets attached to the next message, as removable pills above the text. */
export function ComposerAttachments({
  selected,
  selections,
  onChange,
}: ComposerAttachmentsProps) {
  return (
    <ContextRow
      contextItems={[
        ...buildAdStudioTemplateContextItems(
          selected.adTemplates,
          selected.adTemplates.map(({ id }) => id),
        ),
        ...[...selected.emailTemplates, ...selected.emailComponents].map(
          emailAssetItem,
        ),
      ]}
      onRemoveContextItem={(itemId) => {
        const without = (assets: SelectedEmailAsset[]) =>
          assets.filter(({ id }) => id !== itemId);
        onChange({
          adTemplateIds: selections.adTemplateIds.filter((id) => id !== itemId),
          emailTemplates: without(selections.emailTemplates),
          emailComponents: without(selections.emailComponents),
        });
      }}
    />
  );
}

function emailAssetItem(asset: SelectedEmailAsset): ContextItem {
  const preview = (size: string) => (
    <Box width={size} height={size} overflow="hidden" bg="white">
      <FillEmailPreview
        html={asset.html}
        wrapAsComponent={asset.kind === "component"}
      />
    </Box>
  );
  return {
    id: asset.id,
    label: asset.name,
    thumbnail: preview("32px"),
    popoverPreview: preview("200px"),
    referenceAssetId: null,
  };
}
